import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as static_ddl_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			options: [
				{
					value: "Esq",
					text: "Esq"
				},
				{
					value: "II",
					text: "II"
				},
				{
					value: "III",
					text: "III"
				},
				{
					value: "IV",
					text: "IV"
				},
				{
					value: "V",
					text: "V"
				},
				{
					value: "Jr",
					text: "Jr"
				},
				{
					value: "Sr",
					text: "Sr"
				}
			]
		},
		static_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
